import React, { useEffect, useState } from 'react';
import { Layout, Menu, Button, Drawer, Grid, theme } from 'antd';
import {
  DashboardOutlined,
  MedicineBoxOutlined,
  FileTextOutlined,
  LogoutOutlined,
  ShopOutlined,
  TeamOutlined,
  MenuOutlined,
} from '@ant-design/icons';
import { useNavigate, useLocation } from 'react-router-dom';

const { Sider, Content, Header } = Layout;
const { useBreakpoint } = Grid;

const menuItems = [
  { key: '/dashboard',     icon: <DashboardOutlined />,    label: 'Дашборд' },
  { key: '/doctors',       icon: <MedicineBoxOutlined />,  label: 'Врачи' },
  { key: '/pharmacy',      icon: <ShopOutlined />,         label: 'Аптеки' },
  { key: '/prescriptions', icon: <FileTextOutlined />,     label: 'Рецепты' },
  { key: '/users',         icon: <TeamOutlined />,         label: 'Пользователи' },
];

export default function AppLayout({ children }: { children: React.ReactNode }) {
  const navigate = useNavigate();
  const location = useLocation();
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [collapsed, setCollapsed] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { token } = theme.useToken();

  useEffect(() => {
    setDrawerOpen(false);
  }, [location.pathname]);

  function handleLogout() {
    localStorage.removeItem('admin_token');
    navigate('/login');
  }

  function onMenuClick(key: string) {
    navigate(key);
    if (isMobile) setDrawerOpen(false);
  }

  const brand = (
    <div style={{
      height: 64, display: 'flex', alignItems: 'center',
      justifyContent: 'center', color: '#fff',
      fontWeight: 700, fontSize: collapsed && !isMobile ? 14 : 18,
      borderBottom: '1px solid #1f3a5f',
    }}>
      {collapsed && !isMobile ? 'Rx' : '💊 Мои рецепты'}
    </div>
  );

  const menu = (
    <Menu
      theme="dark"
      selectedKeys={[location.pathname]}
      items={menuItems}
      onClick={({ key }) => onMenuClick(key)}
      style={{ marginTop: 8 }}
    />
  );

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {!isMobile && (
        <Sider
          collapsible
          collapsed={collapsed}
          onCollapse={setCollapsed}
          theme="dark"
          breakpoint="lg"
        >
          {brand}
          {menu}
        </Sider>
      )}

      {isMobile && (
        <Drawer
          placement="left"
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          width={260}
          styles={{ body: { padding: 0, background: '#001529' }, header: { background: '#001529', borderBottom: '1px solid #1f3a5f' } }}
          closeIcon={<span style={{ color: '#fff' }}>×</span>}
          title={<span style={{ color: '#fff', fontWeight: 700 }}>💊 Мои рецепты</span>}
        >
          {menu}
        </Drawer>
      )}

      <Layout style={{ maxWidth: '100vw' }}>
        <Header style={{
          background: token.colorBgContainer,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: isMobile ? '0 12px' : '0 24px',
          borderBottom: `1px solid ${token.colorBorderSecondary}`,
          position: 'sticky',
          top: 0,
          zIndex: 10,
          height: 56,
          lineHeight: '56px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setDrawerOpen(true)}
                aria-label="Меню"
              />
            )}
            {isMobile && (
              <span style={{ fontWeight: 600, fontSize: 15 }}>Мои рецепты</span>
            )}
          </div>
          <Button
            icon={<LogoutOutlined />}
            onClick={handleLogout}
            danger
            type="text"
          >
            {isMobile ? null : 'Выйти'}
          </Button>
        </Header>

        <Content style={{
          margin: isMobile ? 12 : 24,
          minHeight: 280,
          overflowX: 'hidden',
        }}>
          {children}
        </Content>
      </Layout>
    </Layout>
  );
}
